module.exports = __webpack_public_path__ + "img/technology8.3c64b21e.png";